var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "Capa_1",
        "enable-background": "new 0 0 512 512",
        height: "26",
        viewBox: "0 0 512 512",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#48B6E7", "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m261.173 395.616-62.787-.056-9.411 47.86h72.198 72.171l-9.383-47.86z",
            fill: "#838383",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m333.344 443.42h-72.17-72.199-36.199c-14.343 0-26.05 11.724-26.05 26.054v21.098c0 2.719 2.211 4.928 4.932 4.928h259.031c2.693 0 4.932-2.209 4.932-4.928v-21.098c0-14.33-11.735-26.054-26.079-26.054z",
            fill: "#cecece",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m261.173 395.616-62.787-.056-3.742 19.059 45.524.028 62.788-.056 5.641 28.829h24.747l-9.383-47.86z",
            fill: "#595959",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m255.901 16.5h222.35c14.428 0 26.249 11.781 26.249 26.224v326.612c0 14.415-11.821 26.224-26.249 26.224h-444.502c-14.457 0-26.249-11.81-26.249-26.224v-326.612c0-14.443 11.792-26.224 26.249-26.224z",
            fill: "#cecece",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m369.542 443.42h-36.199c14.343 0 26.079 11.724 26.079 26.054v21.098c0 2.719-2.239 4.928-4.961 4.928h36.227c2.693 0 4.932-2.209 4.932-4.928v-21.098c.001-14.33-11.735-26.054-26.078-26.054z",
            fill: "#b5adb6",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m260.068 354.581h-206.363c-3.061 0-5.556-2.464-5.556-5.522v-286.086c0-3.03 2.494-5.522 5.556-5.522h202.281 202.309c3.033 0 5.528 2.492 5.528 5.522v286.086c0 3.059-2.495 5.522-5.528 5.522z",
            fill: "#f9f7f7",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m434.342 354.581h23.953c3.033 0 5.528-2.464 5.528-5.522v-1.671-284.415c0-3.03-2.495-5.522-5.528-5.522h-60.69v5.522 286.086 5.522z",
            fill: "#e2e2e2",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m478.251 16.5h-106.895c14.428 0 26.249 11.781 26.249 26.224v14.726h60.69c3.033 0 5.528 2.492 5.528 5.522v258.049 26.366 1.671c0 3.059-2.495 5.522-5.528 5.522h-23.953l-36.737-.085v14.755c0 14.415-11.82 26.224-26.249 26.224l103.975.085h2.92c9.128 0 17.206-4.729 21.912-11.866 2.75-4.135 4.337-9.062 4.337-14.358v-7.788-318.823c0-14.443-11.82-26.224-26.249-26.224z",
            fill: "#b5adb6",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m129.022 135.5-17.065 17.049c-3.543 3.54-3.543 9.317 0 12.829l6.945 6.967c-2.466 4.616-4.479 9.544-5.924 14.698h-10.006c-4.989 0-9.099 4.078-9.099 9.091v24.1c0 4.984 4.11 9.062 9.099 9.062h10.375c1.531 5.013 3.543 9.77 6.009 14.273l-7.398 7.391c-3.543 3.54-3.543 9.317 0 12.829l17.065 17.048c3.515 3.54 9.298 3.54 12.841 0l7.398-7.391c4.507 2.464 9.269 4.475 14.258 6.004v10.365c0 4.984 4.11 9.062 9.099 9.062h24.123c5.017 0 9.099-4.078 9.099-9.062v-9.997c5.159-1.444 10.063-3.455 14.712-5.919l6.945 6.938c3.543 3.54 9.326 3.54 12.841 0l17.093-17.048c3.515-3.512 3.515-9.289 0-12.829l-6.576-6.57c2.665-4.729 4.847-9.77 6.435-15.094h9.099c5.017 0 9.099-4.078 9.099-9.062v-24.1c0-5.013-4.082-9.091-9.099-9.091h-8.702c-1.559-5.466-3.713-10.648-6.378-15.548l6.123-6.117c3.515-3.512 3.515-9.289 0-12.829l-17.094-17.049c-3.515-3.512-9.298-3.512-12.841 0l-6.095 6.117c-4.904-2.662-10.091-4.814-15.562-6.372v-8.722c0-4.984-4.082-9.062-9.099-9.062h-24.123c-4.989 0-9.099 4.078-9.099 9.062v9.119c-5.301 1.586-10.346 3.766-15.08 6.429l-6.576-6.57c-3.545-3.513-9.327-3.513-12.842-.001z",
            fill: "#838383",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m198.102 226.717c-1.304 13.905-4.365 26.932-8.901 38.571-4.195 10.875-9.695 20.532-16.101 28.49-1.247 1.558-2.523 3.059-3.855 4.475 1.049.396 2.183.623 3.373.623h24.123c3.572 0 6.69-2.067 8.164-5.098.595-1.189.935-2.549.935-3.965v-9.997c5.159-1.444 10.063-3.455 14.712-5.919l6.945 6.938c3.543 3.54 9.326 3.54 12.841 0l17.093-17.048c3.515-3.512 3.515-9.289 0-12.829l-6.576-6.57c2.665-4.729 4.847-9.77 6.435-15.094h9.099c5.017 0 9.099-4.078 9.099-9.062v-24.1c0-5.013-4.082-9.091-9.099-9.091h-8.702c-1.559-5.466-3.713-10.648-6.378-15.548l6.123-6.117c3.515-3.512 3.515-9.289 0-12.829l-17.093-17.047c-3.515-3.512-9.298-3.512-12.841 0l-6.095 6.117c-4.904-2.662-10.091-4.814-15.562-6.372v-8.722c0-4.984-4.082-9.062-9.099-9.062h-24.123c-2.041 0-3.94.68-5.471 1.841-.765.595-1.474 1.303-2.013 2.124 16.044 14.868 27.836 39.053 32.003 67.543 1.219.793 2.353 1.671 3.373 2.662 4.365 4.191 7.087 10.053 7.087 16.539 0 6.514-2.721 12.376-7.087 16.539-.736.734-1.558 1.414-2.409 2.008z",
            fill: "#595959",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m184.694 185.286c-12.671 0-22.932 10.252-22.932 22.882 0 12.659 10.261 22.911 22.932 22.911 12.643 0 22.904-10.252 22.904-22.911 0-12.631-10.261-22.882-22.904-22.882z",
            fill: "#f9f7f7",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            "clip-rule": "evenodd",
            d: "m187.16 208.168c0 8.977-5.159 16.737-12.699 20.503 3.09 1.529 6.548 2.407 10.233 2.407 4.989 0 9.638-1.614 13.408-4.361.85-.595 1.672-1.274 2.409-2.011 4.365-4.163 7.087-10.025 7.087-16.539 0-6.485-2.721-12.347-7.087-16.539-1.02-.991-2.154-1.869-3.373-2.662-3.6-2.322-7.852-3.682-12.444-3.682-3.685 0-7.143.878-10.233 2.407 7.54 3.74 12.699 11.5 12.699 20.477z",
            fill: "#e2e2e2",
            "fill-rule": "evenodd",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d: "m478.251 9h-444.502c-18.609 0-33.749 15.128-33.749 33.724v326.612c0 18.596 15.14 33.724 33.749 33.724h155.518l-6.467 32.889h-30.024c-18.515 0-33.579 15.04-33.579 33.526v21.098c0 6.853 5.59 12.428 12.46 12.428h259.031c6.855 0 12.433-5.575 12.433-12.428v-21.098c0-18.486-15.063-33.526-33.579-33.526h-30.02l-6.448-32.889h145.177c18.609 0 33.749-15.128 33.749-33.724v-326.612c0-18.596-15.14-33.724-33.749-33.724zm-154.015 426.948h-45.97c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h91.276c10.245 0 18.579 8.311 18.579 18.526v18.526h-253.924v-18.525c0-10.216 8.334-18.526 18.579-18.526h90.851c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-45.54l6.467-32.889h113.234zm172.764-66.612c0 10.324-8.411 18.724-18.749 18.724h-279.917c-.008 0-.015 0-.022 0h-164.563c-10.338 0-18.749-8.4-18.749-18.724v-326.612c0-10.325 8.411-18.724 18.749-18.724h444.502c10.338 0 18.749 8.399 18.749 18.724z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m458.295 49.95h-404.59c-7.199 0-13.056 5.842-13.056 13.022v286.086c0 7.196 5.857 13.051 13.057 13.051l189.922-.028c4.142-.001 7.5-3.359 7.499-7.501 0-4.143-3.359-7.5-7.501-7.499l-187.977.028v-282.159h400.674v282.159l-178.056-.028s0 0-.001 0c-4.142 0-7.5 3.357-7.5 7.499s3.356 7.5 7.499 7.501l180.03.028c7.184 0 13.028-5.854 13.028-13.051v-286.085c0-7.181-5.844-13.023-13.028-13.023z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m324.459 286.5v-40.554c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v40.554c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m375.029 286.5v-81.079c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v81.079c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m425.6 286.5v-140.268c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v140.268c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m260.039 242.962c.964-2.027 1.841-4.086 2.628-6.167h3.722c9.153 0 16.599-7.43 16.599-16.563v-24.101c0-9.148-7.446-16.591-16.599-16.591h-3.251c-.803-2.217-1.704-4.408-2.699-6.566l2.294-2.292c6.442-6.437 6.451-16.942-.005-23.445l-17.088-17.043c-6.438-6.432-16.944-6.441-23.455.012l-2.272 2.28c-2.161-.994-4.354-1.895-6.572-2.696v-3.268c0-9.133-7.446-16.563-16.599-16.563h-24.123c-9.153 0-16.599 7.43-16.599 16.563v3.744c-2.078.786-4.132 1.662-6.157 2.624l-2.72-2.718c-6.477-6.419-16.984-6.411-23.421.021l-17.064 17.048c-3.141 3.138-4.866 7.315-4.857 11.765.009 4.435 1.742 8.589 4.846 11.665l3.167 3.177c-.841 1.873-1.609 3.773-2.302 5.692h-4.539c-9.153 0-16.599 7.442-16.599 16.591v24.101c0 9.133 7.446 16.563 16.599 16.563h5.021c.682 1.792 1.425 3.56 2.228 5.298l-3.563 3.561c-3.141 3.138-4.866 7.315-4.857 11.765.009 4.435 1.742 8.589 4.857 11.676l17.041 17.025c3.11 3.132 7.264 4.862 11.698 4.871 4.476-.031 8.627-1.713 11.765-4.85l3.57-3.565c1.734.8 3.499 1.542 5.287 2.224v5.014c0 9.133 7.446 16.563 16.599 16.563h24.123c9.153 0 16.599-7.43 16.599-16.563v-4.528c1.913-.69 3.813-1.459 5.694-2.302l3.162 3.158c3.131 3.128 7.295 4.85 11.731 4.85h.035c4.434-.01 8.588-1.739 11.672-4.845l17.098-17.053c6.442-6.437 6.451-16.942 0-23.44zm-14.485 6.732 6.555 6.549c.6.604.61 1.651.026 2.234l-17.119 17.074c-.359.362-.788.438-1.084.439-.291-.002-.752-.08-1.134-.461l-6.945-6.938c-2.328-2.327-5.903-2.862-8.813-1.321-4.305 2.281-8.753 4.072-13.222 5.323-3.239.907-5.478 3.859-5.478 7.223v9.996c0 .847-.732 1.563-1.599 1.563h-24.123c-.852 0-1.599-.73-1.599-1.563v-10.364c0-3.296-2.151-6.205-5.302-7.171-4.464-1.368-8.79-3.189-12.858-5.414-1.131-.618-2.368-.919-3.595-.919-1.941 0-3.86.753-5.303 2.194l-7.399 7.391c-.381.381-.824.461-1.13.461-.325.028-.728-.075-1.109-.461l-17.086-17.069c-.36-.356-.437-.78-.437-1.073 0-.303.079-.743.458-1.123l7.398-7.392c2.358-2.355 2.878-5.985 1.277-8.908-2.23-4.071-4.051-8.397-5.415-12.86-.963-3.155-3.875-5.31-7.173-5.31h-10.375c-.852 0-1.599-.73-1.599-1.563v-24.101c0-.862.732-1.591 1.599-1.591h10.006c3.362 0 6.313-2.237 7.221-5.474 1.268-4.521 3.058-8.958 5.318-13.189 1.554-2.909 1.025-6.493-1.304-8.829l-6.977-6.999c-.36-.356-.437-.78-.437-1.073 0-.303.079-.743.458-1.123l17.064-17.048c.594-.593 1.65-.585 2.24 0l6.576 6.569c2.378 2.375 6.046 2.879 8.977 1.231 4.351-2.447 8.911-4.392 13.553-5.779 3.176-.949 5.352-3.871 5.352-7.186v-9.119c0-.832.747-1.563 1.599-1.563h24.123c.867 0 1.599.716 1.599 1.563v8.723c0 3.352 2.224 6.297 5.447 7.214 4.806 1.367 9.529 3.302 14.037 5.749 2.922 1.586 6.542 1.058 8.891-1.298l6.062-6.083c.61-.604 1.667-.615 2.265-.017l17.067 17.021c.6.604.61 1.651.021 2.239l-6.123 6.117c-2.352 2.35-2.876 5.968-1.288 8.889 2.449 4.502 4.385 9.22 5.754 14.021.919 3.221 3.863 5.442 7.212 5.442h8.703c.882 0 1.599.714 1.599 1.591v24.101c0 .847-.732 1.563-1.599 1.563h-9.1c-3.316 0-6.239 2.179-7.187 5.356-1.385 4.643-3.33 9.204-5.782 13.556-1.649 2.937-1.145 6.611 1.237 8.99z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m184.694 177.785c-16.781 0-30.433 13.63-30.433 30.383 0 16.769 13.652 30.411 30.433 30.411 16.765 0 30.404-13.643 30.404-30.411 0-16.753-13.639-30.383-30.404-30.383zm0 45.794c-8.51 0-15.433-6.913-15.433-15.411 0-8.482 6.923-15.383 15.433-15.383 8.494 0 15.404 6.9 15.404 15.383 0 8.498-6.91 15.411-15.404 15.411z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }